import jQuery from "jquery";

export default () => {

    jQuery(document).ready(function ($) {

        const $buttonMenu = $('.menu-toggle');
        const $nav = $('.menu-main-menu-container > ul');

        $(document).mouseup(e => {
            if (!$buttonMenu.is(e.target) && $buttonMenu.has(e.target).length === 0) {
                $buttonMenu.removeClass('m-open m-close');
            }
        });

        $buttonMenu.on('click', () => {
            $nav.toggle('400');
            $buttonMenu.toggleClass('m-open m-close');
        });



        // sub-menu dropdown
        $('#site-navigation .menu .sub-menu').hide(400);
        $('#site-navigation .menu-item-has-children a')
            .click(function () {
                $(this).parent().children('.sub-menu').toggle(400);
            });
        $('#site-navigation ul').prepend('<li class="menu-title">Menu</li>');

    });

}